"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var styled_components_1 = __importStar(require("styled-components"));
exports.TextCaptionWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    ", "\n    z-index: 2;\n"], ["\n    position: absolute;\n    ",
    "\n    z-index: 2;\n"])), function (props) { return props.theme && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        left: ", ";\n        bottom: ", ";\n    "], ["\n        left: ", ";\n        bottom: ", ";\n    "])), props.theme.Spacing[5], props.theme.Spacing[3]); });
var templateObject_1, templateObject_2;
